import { ICalculatorInput } from "../@shared/models/ICalculatorInput";
import { ICalculatorOutput } from "../@shared/models/ICalculatorOutput";
import IValidationResult from "../@shared/models/IValidationResult";

interface IProps {
  inputValidation: IValidationResult;
  calculatorInput: ICalculatorInput;
  calculatorOutput: ICalculatorOutput;
  onAddToCartClicked: () => void;
  submitting: boolean;
}

function AddToCart({
  inputValidation,
  calculatorInput,
  calculatorOutput,
  onAddToCartClicked,
  submitting,
}: IProps) {
  return (
    <>
      <tr>
        <th className="label">
          <label htmlFor="cq-pod-paper-size">Price per copy</label>
          <span
            className="woo-selected-variation-item-name"
            data-default=""
          ></span>
        </th>
        <td className="value">
          {inputValidation.isValid && calculatorOutput.hasPrice
            ? "€ " +
              (calculatorOutput.grandTotal / calculatorInput.numCopies).toFixed(
                2,
              )
            : ""}{" "}
        </td>
      </tr>

      <tr>
        <th className="label">
          <label htmlFor="cq-pod-paper-size">Total</label>
          <span
            className="woo-selected-variation-item-name"
            data-default=""
          ></span>
        </th>
        <td className="value">
          {inputValidation.isValid && calculatorOutput.hasPrice
            ? "€ " + calculatorOutput.grandTotal.toFixed(2)
            : ""}{" "}
        </td>
      </tr>

      <tr>
        <th className="label"></th>
        <td className="value">
          <button
            disabled={
              !inputValidation.isValid ||
              !calculatorOutput.hasPrice ||
              submitting
            }
            onClick={onAddToCartClicked}
          >
            Add to Cart
          </button>
        </td>
      </tr>
    </>
  );
}

export default AddToCart;
